import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import Excel from 'exceljs';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import { cmmUtils } from 'utils/cmmUtils.js';

export default function ExcelUpload(props) {
    // warning / onSaved 는 선택 항목이다. 넘기지 않으면 기존 동작 그대로다.
    const {open, url, params, handleClose, rows, columns, columnNm, sampleFileName, warning, onSaved} = props;

    const [file, setFile] = useState();
    const [fileName, setFileName] = useState();

    const readExcelFile = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    };

    const handleSave = (e) => {
        let dataList = [];
        let column = [];

        const workbook = new Excel.Workbook();
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);
        reader.onload = () => {
            const buffer = reader.result;
            workbook.xlsx.load(buffer).then(wb => {
                wb.eachSheet((sheet, id) => {
                    //rowIndex 및 columnIndex 가 1부터 시작하므로 유의.
                    sheet.eachRow((row, rowIndex) => {
                        if (rowIndex === 1) {
                            // console.log(`rowIndex ${rowIndex} 컬럼한글명: ${row.values[1]} ${row.values[2]}`);
                        } else if (rowIndex === 2) {
                            // console.log(`rowIndex ${rowIndex} 컬럼영문명: ${column}`);
                            for (let i = 1; i < row.values.length; i++) {
                                column.push(row.values[i]);
                            }
                        } else {
                            let dataInfo = {};
                            for (let i = 1; i < row.values.length; i++) {
                                dataInfo[column[i - 1]] = row.values[i] !== undefined ? row.values[i] : null;
                            }
                            dataList.push(dataInfo);
                        }
                    });
                });
                return dataList;
            }).then(result => {
                const reParams = { ...params, dataList:result };
                axios.post(url, reParams
                ).then(function (response) {
                    alert(response.data.message)
                    if (onSaved) onSaved();
                    handleClose();
                }).catch(function (error) {
                    alert(error.response.data.message)
                });
            })
        }
    }

    const handleExcelDown = () => {
        cmmUtils.excelDownload(rows, sampleFileName, columns, columnNm);
    }

    useEffect(() => {
        setFile(null)
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle id="draggable-dialog-title">
                엑셀 업로드
            </DialogTitle>
            <DialogContent dividers>
                {!!warning && <Box sx={{color: 'error.main', whiteSpace: 'pre-line'}}>{warning}</Box>}
                <Box sx={{mt: 3}}>
                    <input type="file" onChange={readExcelFile}/>
                </Box>
            </DialogContent>
            <DialogActions>
                {!!sampleFileName && <Button variant="outlined" color="error" onClick={handleExcelDown}>양식 다운</Button>}
                <Button variant="outlined" color="success" onClick={handleSave} disabled={file ? false : true} autoFocus>등록</Button>
                <Button variant="outlined" color="success" onClick={handleClose}>닫기</Button>
            </DialogActions>
        </Dialog>
    );
}